// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
body {
  line-height: 1.3;
}

.poliSer_policy-wapper__OcYRf {
  max-width: 800px; /* Đặt chiều rộng cố định giống nhau */
  margin: auto;
  text-align: left;
  padding: 10px 20px;
  background-color: #ffffff;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.5);
  border-radius: 8px;
}

.poliSer_service-wapper__XReri {
  max-width: 800px; /* Đặt chiều rộng cố định giống nhau */
  margin: auto;
  text-align: left;
  padding: 10px 20px;
  background-color: #ffffff;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.5);
  border-radius: 8px;
}

h1 {
  text-align: center;
  color: #333;
  font-weight: 700;
  padding: 20px 0;
}

h2 {
  font-weight: 700;
}

li {
  margin-bottom: 10px;
  list-style: circle !important;
}

.poliSer_d-flex__ArlQl {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90vh;
}`, "",{"version":3,"sources":["webpack://./src/pages/poliService/poliSer.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,gBAAA;AAEJ;;AAEA;EACI,gBAAA,EAAA,sCAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yCAAA;EACA,kBAAA;AACJ;;AACG;EAEC,gBAAA,EAAA,sCAAA;EAEA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yCAAA;EACA,kBAAA;AAAJ;;AAIE;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AADJ;;AAGE;EACE,gBAAA;AAAJ;;AAGE;EACE,mBAAA;EACA,6BAAA;AAAJ;;AAGE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAAJ","sourcesContent":["body{\n    line-height: 1.3;\n}\n\n\n.policy-wapper {\n    max-width: 800px; /* Đặt chiều rộng cố định giống nhau */\n    margin: auto;\n    text-align: left;\n    padding: 10px 20px;\n    background-color: #ffffff;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.5);\n    border-radius: 8px;\n  }\n   .service-wapper {\n    // min-width: 500px; /* Đặt chiều rộng cố định giống nhau */\n    max-width: 800px; /* Đặt chiều rộng cố định giống nhau */\n\n    margin: auto;\n    text-align: left;\n    padding: 10px 20px;\n    background-color: #ffffff;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.5);\n    border-radius: 8px;\n  }\n  \n  \n  h1 {\n    text-align: center; // Căn giữa tiêu đề chính\n    color: #333; // Màu chữ\n    font-weight: 700;\n    padding: 20px 0;\n  }\n  h2{\n    font-weight: 700;\n  }\n  \n  li {\n    margin-bottom: 10px; // Khoảng cách giữa các mục\n    list-style: circle !important;\n  }\n  \n  .d-flex {\n    display: flex;\n    justify-content: center; // Căn giữa theo chiều ngang\n    align-items: center; // Căn giữa theo chiều dọc\n    height: 90vh; // Chiều cao toàn màn hình\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"policy-wapper": `poliSer_policy-wapper__OcYRf`,
	"service-wapper": `poliSer_service-wapper__XReri`,
	"d-flex": `poliSer_d-flex__ArlQl`
};
export default ___CSS_LOADER_EXPORT___;
